import tw, {styled} from 'twin.macro';

const Em = styled.span((props) => [
  tw`
    font-bold
  `,
]);

export default Em;
